import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { openCookiePreferences } from "@/lib/consent";


const Footer = () => {
  const { t } = useLanguage();

  const regions = [
    { name: "Barra da Tijuca", link: "/barra-da-tijuca" },
    { name: "Copacabana", link: "/copacabana" },
    { name: "Ipanema", link: "/ipanema" },
    { name: "Leblon", link: "/leblon" },
    { name: "Botafogo", link: "/botafogo" },
    { name: "Tijuca", link: "/tijuca" },
    { name: "Recreio dos Bandeirantes", link: "/recreio-dos-bandeirantes" },
    { name: "Lançamentos", link: "/lancamentos" },
    { name: "Avaliação de Imóvel", link: "/avaliacao" },
    { name: "Anuncie seu Imóvel", link: "/anuncie-seu-imovel" },
    { name: "Blog", link: "/blog" },
  ];

  return (
    <footer className="bg-primary border-t border-primary-foreground/10 py-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <span className="font-display text-xl font-bold text-primary-foreground">TOPCLASS</span>
            <span className="text-xs text-accent font-body font-semibold tracking-widest ml-2">IMOBILIÁRIA PREMIUM</span>
            <p className="text-primary-foreground/70 font-body text-sm mt-3">
              {t("footer.tagline")}
            </p>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-primary-foreground mb-3">{t("footer.regions")}</h4>
            <ul className="space-y-1 text-sm font-body">
              {regions.map((r) => (
                <li key={r.name}>
                  <Link
                    to={r.link}
                    title={`${r.name} — TopClass Imóveis`}
                    className="text-primary-foreground/70 hover:text-accent transition-colors"
                  >
                    {r.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-bold text-primary-foreground mb-3">{t("footer.contact")}</h4>
            <ul className="space-y-1 text-sm text-primary-foreground/70 font-body">
              <li>+55 21 97354-8387</li>
              <li>contato@topclassimoveis.com</li>
              <li className="mt-2">
                Av. das Américas, 3500 – Bloco 4, Sala 218<br />
                Barra da Tijuca – Rio de Janeiro, RJ<br />
                CEP: 22640-102
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-primary-foreground/10 mt-8 pt-6 text-center text-xs text-primary-foreground/50 font-body">
          © {new Date().getFullYear()} {t("footer.rights")}
          <span className="mx-2">·</span>
          <button
            type="button"
            onClick={openCookiePreferences}
            className="underline underline-offset-2 hover:text-primary-foreground/80 transition-colors"
          >
            Preferências de cookies
          </button>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
